import * as React from 'react';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import '@grandvisionhq/icons';
import '@grandvisionhq/iris-ui';
import { CheckoutForm } from '../../../components/Forms/CheckoutForm.js';
import { FormFieldsWithCart } from '../../../components/FormFieldsWithCart/FormFieldsWithCart.js';
import { useIsFormSlotAvailable } from '../../../slots/forms/form-context.js';
import '../../../slots/summaries/summary-context.js';
import '../../../slots/summaries/types.js';
import { ShippingObjectTypes } from '../../../state.js';
import { updateShippingDetails } from '../../actions.js';
import { getBillingAddressFormData, isPrefillFinished } from '../../selectors.js';

const BillingForm = ()=>{
    const dispatch = useDispatch();
    const isBillingFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.BillingAddress);
    const billingAddressInitialData = useSelector(getBillingAddressFormData);
    const isPrefillFinished$1 = useSelector(isPrefillFinished);
    const handleChange = React.useCallback((formData)=>{
        dispatch(updateShippingDetails({
            form: formData
        }));
    }, [
        dispatch
    ]);
    if (!isBillingFormAvailable) return null;
    if (!billingAddressInitialData || !isPrefillFinished$1) return null;
    return /*#__PURE__*/ React.createElement(CheckoutForm, {
        formName: "billingAddress",
        "data-t": "billingAddress",
        initialFormState: billingAddressInitialData,
        onChange: handleChange
    }, /*#__PURE__*/ React.createElement(FormFieldsWithCart, {
        formName: ShippingObjectTypes.BillingAddress
    }));
};

export { BillingForm };
//# sourceMappingURL=BillingForm.js.map
